import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  TextField,
  Typography,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";

const ui = {
  primary: "#009db9",
  primaryDark: "#007a8a",
  primarySoft: "#e6f6f9",
  muted: "#6b7280",
  text: "#1f2933",
};

const fieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    backgroundColor: "#fff",
    "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: ui.primary },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: ui.primary,
    },
    "&.Mui-disabled": { backgroundColor: "#f3f5f7" },
  },
  "& label.Mui-focused": { color: ui.primary },
};

const primaryButtonSx = {
  backgroundColor: ui.primary,
  color: "#fff",
  borderRadius: "10px",
  textTransform: "none",
  fontWeight: 700,
  px: 3,
  py: 1.25,
  boxShadow: "none",
  "&:hover": { backgroundColor: ui.primaryDark, boxShadow: "none" },
  "&.Mui-disabled": { backgroundColor: "#d5dbe0", color: "#8a949e" },
};

const DialogHeader = ({ icon: Icon, title }) => (
  <DialogTitle
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 1.5,
      fontWeight: 700,
      color: ui.text,
      pb: 1.5,
    }}
  >
    <Box
      sx={{
        width: 36,
        height: 36,
        borderRadius: "10px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: ui.primarySoft,
        color: ui.primary,
      }}
    >
      <Icon fontSize="small" />
    </Box>
    {title}
  </DialogTitle>
);

const CompleteTaskDialog = ({
  openCompleteDialog,
  setOpenCompleteDialog,
  completedDate,
  setCompletedDate,
  handleConfirmCompleteTask,
  isMobile,
}) => {
  return (
    <Dialog
      open={openCompleteDialog}
      onClose={() => setOpenCompleteDialog(false)}
      maxWidth="sm"
      fullWidth
      fullScreen={isMobile}
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: { xs: 0, sm: "16px" },
          m: { xs: 0, sm: 2 },
          width: { xs: "100%", sm: "auto" },
          maxWidth: { xs: "100%", sm: "500px" },
        },
      }}
    >
      <DialogHeader icon={CheckCircleOutlineIcon} title="Complete Task" />
      <Divider />
      <DialogContent sx={{ pt: 2.5 }}>
        <Typography
          sx={{
            mb: 3,
            color: ui.text,
            fontSize: { xs: "0.95rem", sm: "1rem" },
          }}
        >
          Select the completion date and time for the task:
        </Typography>
        <DateTimePicker
          label="Completion Date and Time"
          value={completedDate}
          onChange={setCompletedDate}
          renderInput={(params) => (
            <TextField {...params} fullWidth sx={fieldSx} />
          )}
        />
      </DialogContent>
      <Divider />
      <DialogActions sx={{ px: 3, py: 2, gap: 1 }}>
        <Button
          onClick={() => setOpenCompleteDialog(false)}
          sx={{ color: ui.muted, textTransform: "none", fontWeight: 600 }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleConfirmCompleteTask}
          disabled={!completedDate || !completedDate.isValid()}
          sx={{ ...primaryButtonSx, py: 1 }}
        >
          Complete Task
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CompleteTaskDialog;